import Vue from 'vue';
import moment from 'moment';
import i18n from '../plugins/i18n';

const dateFormat = (date: Date, format: string) => {
    moment.locale(i18n.locale);
    return moment(date).format(format);
}

Vue.filter('date', (date: Date, format: string) => {
    if (date === null) return '';
    return dateFormat(date, format || 'll');
});

Vue.filter('dateTime', (date: Date, format: string) => {
    if (date === null) return '';
    return dateFormat(date, format || 'lll');
});